// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // pathologyURL: 'http://tomcat3.econsult.hu:8080/patology/',
  pathologyURL: 'https://testdockertopsy.nauticom.hu/',
  // pathologyURL: 'https://testnautopsy.nauticom.hu/',
  eszigReader: 'http://localhost:19750',
  // eesztRssURL: 'https://rss.office.eeszt.gov.hu/teszt/rss/eeszt'
  eesztRssURL: 'https://rss.office.eeszt.gov.hu/teszt/rss/eeszt'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
